module.exports = __webpack_public_path__ + "static/media/credit11.09d64919.png";